import { Injectable, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { AutoSaveFormControl } from './AutoSaveFormControl';
import { AutoSaveFormGroup } from './AutoSaveFormGroup';
import { Subject } from 'rxjs/Subject';
import 'rxjs/operator/takeUntil';
import { IAutoSave } from './IAutoSave';

@Injectable()
export class AutoSaveFormBuilder extends FormBuilder {
  control(formState: any, validator?: ValidatorFn | ValidatorFn[] | null, asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null, autoSave$?: Subject<boolean> | null, autoSaveCallback?: ((c: AutoSaveFormControl) => void) | null, changeDetectorRef?: ChangeDetectorRef): FormControl {
    var baseControl = super.control(formState, validator, asyncValidator);
    var control = Object.assign(new AutoSaveFormControl(formState, validator, asyncValidator), baseControl);
    this.setupAutoSave(control, autoSave$, autoSaveCallback, changeDetectorRef);
    return control;
  }

  group(controlsConfig: { [key: string]: any; }, extra?: { [key: string]: any; } | null, autoSave$?: Subject<boolean> | null, autoSaveCallback?: ((c: AutoSaveFormGroup) => void) | null, changeDetectorRef?: ChangeDetectorRef): FormGroup {
    var group = super.group(controlsConfig, extra);
    var control = Object.assign(new AutoSaveFormGroup(group.controls), group);
    this.setupAutoSave(control, autoSave$, autoSaveCallback, changeDetectorRef);
    return control;
  }

  private setupAutoSave(control: AbstractControl & IAutoSave, autoSave$: Subject<boolean> | null, autoSaveCallback: ((c: AbstractControl & IAutoSave) => any ) | null, changeDetectorRef: ChangeDetectorRef) {
    if (autoSave$) {
      control.valueChanges
        .debounceTime(1500)
        .distinctUntilChanged()
        .takeUntil(autoSave$)
        .subscribe(() => {
          if (control.dirty && control.valid) {
            autoSaveCallback = autoSaveCallback || (() => setTimeout(() => control.saveSuccess(control.value), 100));
            var result = autoSaveCallback(control);
            if (result !== false) {
              control.initializeSave();
            }
          }
        });
    }
    control.changeDetectionRef = changeDetectorRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/AutoSaveFormBuilder.ts